import { getClosestFraction } from 'components/ManualToolModal/FractionalPitchSlider';
import { NORMAL_FACET_DEFAULT_PITCH } from '../../constants';
import { DivAttrDetail } from './style';

type FacetPitchProps = {
	pitchDeg: number | null;
	showPitchInFraction: boolean;
};

export default function PitchValue({ pitchDeg, showPitchInFraction }: FacetPitchProps) {
	return (
		<DivAttrDetail>
			<label>Pitch:</label>
			<span className="value">{showPitchInFraction ? getClosestFraction(Math.round(pitchDeg ?? NORMAL_FACET_DEFAULT_PITCH)) + '/12'
				: Math.round(pitchDeg ?? NORMAL_FACET_DEFAULT_PITCH)}</span>		
		</DivAttrDetail>
	);
}
